<template>
  <form @submit.prevent="submit" class="position-relative">
    <div class="vuedl-layout__closeBtn" @click="close(true)">
      ×
    </div>
    <v-card>
      <v-container>
        <div class="text-secondary">Поля, обозначенные символом *, обязательны для заполнения</div>

        <div class="mb-5">
          <v-row>
            <v-col lg="6">
              <div>
                <v-select
                  label="Ресурс *"
                  item-text="name"
                  return-object
                  v-model="formTask.unit"
                  :items="unitsList"
                  :error-messages="unitErrors"
                  :readonly="isCreatingBySchedule"
                />
              </div>
              <div>
                <v-text-field label="Место приёма" readonly :value="workplace"></v-text-field>
              </div>

              <v-row>
                <v-col lg="4">
                  <!--  Дата -->
                  <v-menu
                    ref="menu"
                    v-model="datePickerMenu"
                    :close-on-content-click="false"
                    :return-value.sync="formTask.date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        label="Выбор даты *"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        v-model="formTask.date"
                        :error-messages="dateErrors"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="formTask.date" no-title scrollable :readonly="isCreatingBySchedule">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="datePickerMenu = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(formTask.date)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col lg="4">
                  <v-text-field
                    type="time"
                    label="Выбор времени *"
                    prepend-icon="mdi-clock-time-four-outline"
                    v-model="formTask.time"
                    :error-messages="timeErrors"
                  ></v-text-field>
                  <!-- Выбор времени -->
                </v-col>

                <v-col lg="4">
                  <!-- Выбор длительности -->
                  <v-text-field
                    type="number"
                    label="Длительность *"
                    prepend-icon="mdi-clock-time-four-outline"
                    v-model.number="formTask.duration"
                    :error-messages="durationErrors"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col lg="6">
              <v-checkbox label="CITO" v-model="formTask.CITO" hide-details></v-checkbox>

              <div class="d-flex w-100">
                <v-autocomplete
                  label="Пациент"
                  class="mt-4"
                  persistent-hint
                  hide-no-data
                  :item-text="patientName"
                  return-object
                  v-model="formTask.patient"
                  :search-input.sync="search"
                  :loading="patientsLoading"
                  :items="localPatients"
                />
                <!-- <v-autocomplete
                  class="mt-4"
                  label="Пациент *"
                  return-object
                  v-model="formTask.patient"
                  :error-messages="patientErrors"
                  :item-text="patientName"
                  :items="patients"
                ></v-autocomplete> -->
                <!--
                <div class="ml-4">
                  <v-btn>
                    <v-icon right dark>
                      plus_one
                    </v-icon>
                  </v-btn>
                </div>
                -->
              </div>
            </v-col>

            <v-col>
              <v-textarea label="Комментарии" v-model="formTask.description"></v-textarea>
            </v-col>
          </v-row>
        </div>

        <h2>Назначенные услуги</h2>

        <div
          v-if="unitDetail && Array.isArray(unitDetail.services)"
          class="v-data-table v-data-table--has-top v-data-table--has-bottom theme--light"
        >
          <div class="v-data-table__wrapper overflow-auto">
            <table class="table">
              <thead class="v-data-table-header">
                <tr>
                  <th>Назначено</th>
                  <th>Наименование работ</th>
                  <th>Количество</th>
                  <th>Договор</th>
                  <th>Направление</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, idx) in unitDetail.services" :key="`unit-service-${service.id}`">
                  <td>
                    <v-checkbox v-model="formTask.services[idx].selected" />
                  </td>
                  <td>
                    <v-text-field readonly label="Наименование" :value="service.name"></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      type="number"
                      label="Количество"
                      value="1"
                      v-model.number="formTask.services[idx].qty"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-select :items="['Без договора']" value="Без договора" />
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div v-if="servicesErrors.length && this.$v.formTask.services.$error">
              <div v-for="(err, idx) in servicesErrors" :key="`service-err-${idx}`" class="error--text">{{ err }}</div>
            </div>
          </div>
        </div>
        <div v-else>
          Для отображения списка услуг нужно выбрать ресурс
        </div>

        <div class="mt-3">
          <v-btn type="submit" color="primary">Создать</v-btn>
        </div>
      </v-container>
    </v-card>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { IclService } from "@/services/api/icl.service.js";
import { messageHelper } from "@/services/validation-helper.js";
import { formModal } from "@/mixins/modal/form-modal.js";
export default {
  name: "AddTask",
  mixins: [formModal],
  props: {
    /** @type {import("vue").PropType<Unit[]>} */
    units: {
      type: Array,
      default: () => [],
    },

    /** @type {import("vue").PropType<Unit>} */
    unit: {
      type: Object,
      default: null,
    },

    schedule: {
      type: Object,
      default: null,
    },

    patients: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      unitsList: [],
      unitDetail: null,
      timePickerMenu: false,
      datePickerMenu: false,
      patientsLoading: false,
      localPatients: [],
      search: null,
      searchTimeout: null,
      formTask: {
        userId: null,
        unit: null,
        date: this.$date().format("YYYY-MM-DD"),
        time: null,
        duration: null,
        CITO: false,
        patient: null,
        description: null,
        services: [],
      },
    };
  },

  validations() {
    return {
      formTask: {
        unit: { required },
        date: { required },
        time: { required },
        duration: { required },
        patient: { required },
        services: {
          required: param => {
            return Array.isArray(param) && param.filter(item => item.selected).length > 0;
          },
        },
      },
    };
  },

  computed: {
    patient() {
      return this.$store.state.customer.profile;
    },

    isCreatingBySchedule() {
      return this.unit !== null && this.schedule !== null;
    },

    workplace() {
      if (this.unitDetail?.workplace) {
        return this.unitDetail.workplace.name;
      }

      if (!this.unitDetail) {
        return "";
      }

      return "Данных нет";
    },

    unitErrors() {
      return messageHelper(this.$v.formTask.unit);
    },

    dateErrors() {
      return messageHelper(this.$v.formTask.date);
    },

    timeErrors() {
      return messageHelper(this.$v.formTask.time);
    },

    durationErrors() {
      return messageHelper(this.$v.formTask.duration);
    },

    patientErrors() {
      return messageHelper(this.$v.formTask.patient);
    },

    servicesErrors() {
      return messageHelper(this.$v.formTask.services);
    },
  },

  watch: {
    /**
     * @param {Unit} newVal
     * @returns {Promise<void>}
     */
    "formTask.unit": async function(newVal) {
      if (newVal) {
        this.unitDetail = await IclService.getUnit(newVal.id);
        if (this.unitDetail.services) {
          this.formTask.services = this.unitDetail.services.map(item => ({ id: item.id, qty: 1, contract: 0, selected: false }));
        }
      }
    },
    search(val) {
      clearTimeout(this.searchTimeout);
      // Items have already been requested
      if (this.patientsLoading || !val) {
        return;
      }
      this.searchTimeout = setTimeout(async () => {
        this.patientsLoading = true;
        try {
          console.log(`val =>`, val);
          const patients = await IclService.getPatients(val);
          this.localPatients = patients;
          this.patientsLoading = false;
        } catch (error) {
          console.log(`error поиск пациента =>`, error);
        }
      }, 300);
    },
  },

  created() {
    this.localPatients = this.patients;
    if (this.unit) {
      this.unitsList = [this.unit];
      this.formTask.unit = this.unit;
      this.formTask.date = this.$date(this.schedule.date).format("YYYY-MM-DD");
      this.formTask.time = this.schedule.time;
      this.formTask.duration = 15;
    } else {
      this.unitsList = this.units;
    }

    if (this.localPatients.length && this.patient) {
      this.formTask.patient = this.localPatients.find(item => item.id === this.patient.id);
    }
  },

  methods: {
    patientName(val) {
      return `${val.last_name} ${val.first_name} ${val.middle_name}`;
    },

    async submit() {
      this.$v.formTask.$touch();
      if (this.$v.formTask.$pending || this.$v.formTask.$error) {
        return;
      }

      this.formTask.userId = this.$store.getters["auth/getUserId"];
      const response = await IclService.createTimeTask(this.formTask);

      if (response === null) {
        await this.$dialog.message.error("Ошибка добавления");
        return;
      }

      this.formTask = {
        userId: null,
        unit: null,
        date: new Date().toISOString().substr(0, 10),
        time: null,
        duration: null,
        CITO: false,
        patient: null,
        description: null,
        services: [],
      };
      this.unitDetail = null;
      this.$v.formTask.$reset();
      this.$dialog.notify.success("Запись успешно добавлена");
      this.$emit("submit", response);
    },
  },
};
</script>

<style>
input[type="time"]::-webkit-calendar-picker-indicator {
  background: url("/img/time-arrow.svg") center / contain no-repeat;
}
</style>
